import React, { useContext, useState, useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { M_Table, DefaultURl } from 'src/M_Components'

export const RoleConfig = ({ roles, onCreateTab, toastMessages, tablesOrder = [], onTablesOrderUpdate  }) => {
    const { t } = useTranslation()
    const [isLabel, setIsLabel] = useState(true)
    const navigate = useNavigate()
    // const [permissions, setPermissions] = useState([])
    const [lineContextMenu, setLineContextMenu] = useState([])
    const [buttons, setButtons] = useState([])
    const [refresh, setRefresh] = useState(false)


    const NewRoute = (url, label, operation) => {
        sessionStorage.setItem('operation', operation)
        if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            const tempLine = sessionStorage.getItem('lines')
            if (!tempLine) {
                toastMessages('error', '', t("SelectedLine"))
                return
            }
            console.log(tempLine)
            sessionStorage.setItem('rolesLine', JSON.stringify(JSON.parse(tempLine).pop()))
            sessionStorage.removeItem('lines')
        }
        navigate(`${url}`)
        onCreateTab(url, label)
    }

    const newRouteContext = (url, label, operation) => {
        sessionStorage.setItem('operation', operation)
        if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            const tempLine = sessionStorage.getItem('context')
            if (!tempLine) {
                toastMessages('error', '', t("SelectedLine"))
                return
            }
            console.log(tempLine)
            sessionStorage.setItem('rolesLine', tempLine)
            sessionStorage.removeItem('context')
        }
        navigate(`${url}`)
        onCreateTab(url, label)
    }

    useEffect(() => {
        getPermissions()
    }, [])

    const getPermissions = (Type) => {
        const nameForRole = 'role config'
        const tempPerm = []
        const permLines = []
        const permButtons = []
        roles.forEach((role) => {
            if (role.match(nameForRole)) tempPerm.push(role.split(nameForRole)[1])
        })
        permLines.push({ label: t('view'), icon: 'pi pi-search', command: () => newRouteContext("go/RoleConfigCrud", 'View Roles', 'View') })
        if (tempPerm.includes('Create')) permButtons.push({ label: t('Add'), element: 'default', source: '/icons/tableIcons/add.svg', command: () => NewRoute("go/RoleConfigCrud", 'Create Roles', 'Create') })
        if (tempPerm.includes('Edit')) {
            permLines.push({ label: t('Edit'), icon: 'pi pi-pencil', command: () => newRouteContext("go/RoleConfigCrud", 'Edit Roles', 'Edit') })
            permButtons.push({ label: t('Edit'), element: 'default', source: '/icons/tableIcons/edit.svg', command: () => NewRoute("go/RoleConfigCrud", 'Edit Roles', 'Edit') })
        }
        if (tempPerm.includes('Delete')) {
            permLines.push({ label: t('Delete'), icon: 'pi pi-trash', command: () => deleteContext() })
            permButtons.push({ label: t('Delete'), element: 'default', source: '/icons/svgsDaNet/trash-2.svg', style: { filter: 'invert(11%) sepia(68%) saturate(6715%) hue-rotate(359deg) brightness(93%) contrast(115%)' }, command: () => deleteButton() })
        }
        if (tempPerm.includes('Create')) {
            permLines.push({ label: t('Copy'), icon: 'pi pi-copy', command: () => newRouteContext("go/RoleConfigCrud", 'Create Roles', 'Copy') })
            permButtons.push({ label: t('Copy'), element: 'default', source: '/icons/tableIcons/copy.svg', command: () => NewRoute("go/RoleConfigCrud", 'Create Roles', 'Copy') })
        }
        if (Type === 'Context') return permLines
        if (Type === 'Buttons') return permButtons
    }


    const onHide = (e) => {
        setIsLabel(e)
    }

    const getLine = (e) => {
        if (e.length) {
            sessionStorage.setItem('lines', JSON.stringify(e))
        } else {
            sessionStorage.removeItem('lines')
        }
    }

    const getContext = (e) => {
        if (e) {
            sessionStorage.setItem('context', JSON.stringify(e))
        } else {
            sessionStorage.removeItem('context')
        }
    }

    const deleteButton = () => {
        let tempLine = sessionStorage.getItem('lines')
        console.log('DeleteButton', tempLine)
        if (tempLine) {
            tempLine = JSON.parse(tempLine)
            tempLine.forEach(role => {
                axios.delete(`${DefaultURl}viewroledetails/${role.Name}`).then(response => {
                    console.log(response)
                    sessionStorage.removeItem('lines')
                    setRefresh(true)
                    toastMessages('success', '', t("RemoveLine"))
                }).catch(error => {
                    console.log(error)
                    toastMessages('success', '', t("Error"))
                    sessionStorage.removeItem('lines')
                })
            })

        } else {
            toastMessages('error', '', t("SelectedLine"))
            return
        }
    }
    const deleteContext = () => {
        let tempLine = sessionStorage.getItem('context')
        console.log('DeleteContext', tempLine)
        if (tempLine) {
            tempLine = JSON.parse(tempLine)
            axios.delete(`${DefaultURl}viewroledetails/${tempLine.Name}`).then(response => {
                console.log(response)
                sessionStorage.removeItem('context')
                setRefresh(true)
                toastMessages('success', '', t("RemoveLine"))
            }).catch(error => {
                console.log(error)
                toastMessages('success', '', t("Error"))
                sessionStorage.removeItem('context')
            })

        } else {
            toastMessages('error', '', t("SelectedLine"))
            return
        }

    }

    const removeContextItems = ['View', 'Create', 'Copy', 'Edit', 'Print', 'Delete']

    return (
        <>
            <M_Table
                entityName={'Role'}
                roleName={'role config'}
                rolePermissions={roles}
                tablesOrder={tablesOrder}
                onTablesOrderUpdate={onTablesOrderUpdate}
                pageUrl={'Roles Config'}
                lineContext={getPermissions('Context')}
                extraButtons={getPermissions('Buttons')}
                removeContextItems={removeContextItems}
                onHideLabels={onHide}
                onPassLine={getLine}
                onPassContext={getContext}
                refresh={refresh}
                setRefresh={setRefresh}
            />
        </>
    )
}
